import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../../Modal/Modal';
import Heading from '../../Typography/Heading/Heading';
import Button from '../../Button/Button';
import styles from './DeleteFriendsModal.module.scss';
import { useAppDispatch, useAppSelector } from '../../../store/reducers';
import { deleteFriend, getFriendStatus, SocialActionsName } from '../../../store/reducers/Social/slice';
import { clearData } from '../../../store/reducers/Guild/slice';
import cn from 'classnames';
import Loader from '../../Loader/Loader';
const DeleteFriendsModal = ({ closeModal, userName, userId, stakeId }) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const { error, isDataSent, pending, showDeleteModal } = useAppSelector((state) => state.social);
    const deleteFriends = async () => {
        await dispatch(deleteFriend(userId));
        if (stakeId)
            dispatch(getFriendStatus(stakeId));
    };
    useEffect(() => {
        if (!error && showDeleteModal) {
            dispatch(clearData(SocialActionsName.DELETE_FRIENDS));
            closeModal();
        }
    }, [error, dispatch, closeModal, isDataSent]);
    return (_jsxs(Modal, Object.assign({ background: true, closeModal: closeModal }, { children: [_jsx(Heading, { className: styles.heading, title: `Are you sure you want to delete ${userName} from friends?` }), pending.includes(SocialActionsName.DELETE_FRIENDS) ? (_jsx(Button, { className: cn(styles.button, 'w-100'), height: 'sm', size: '100', type: 'submit', text: "", icon: _jsx(Loader, { isTransparent: true }) })) : (_jsx(Button, { onClick: deleteFriends, size: '100', height: 'sm', text: t('delete') }))] })));
};
export default DeleteFriendsModal;
